import { Component } from '@angular/core';
import { DataService } from '../../../../../shared/data.service';
import { Subscription } from 'rxjs';
import { OnInit,OnDestroy } from '@angular/core';
import { Utils } from '../../../../../shared/utils';
import { environment } from '../../../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-season-status',
  imports: [CommonModule, RouterModule],
  templateUrl: './season-status.html',
  styleUrl: './season-status.scss',
  host: {
    '[style.display]': 'lastSeason ? "block" : "none"'
  }
})
export class SeasonStatus implements OnInit,OnDestroy{

  tvDetails:any = {};
  private subscription!: Subscription;
  frontendUrl = environment.frontendUrl;
  backendUrl = environment.backendUrl;

  constructor(private dataService: DataService,private utils:Utils) {}

  ngOnInit(): void {
    this.subscription = this.dataService.message$.subscribe(
      data => this.tvDetails = data
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get lastSeason() {
    const seasons = this.tvDetails?.seasons;
    return Array.isArray(seasons) && seasons.length > 0
      ? seasons[seasons.length - 1]
      : null;
  }

  getSeasonRoute(seasonNumber: number | string | undefined): (string | number)[] {
    const title = this.tvDetails?.name || this.tvDetails?.original_name || 'show';
    const slug = `${this.tvDetails?.id}-${this.utils.movieNameSplitter(title) || 'show'}`;
    return ['/tv', slug, 'season', seasonNumber ?? 1];
  }

  onImageError(event:Event){
    return this.utils.onImageVerticalError(event)
  }

}
